import React, { FC, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import {
  PagedDocument,
  Screen,
  listToBlocks,
} from '@/shared/components/ios-screen';

export const GAME_RULES = [
  'Bhabi is a traditional card game from Punjab, India, for 2 to 9 players.',
  'The player holding the Ace of Spades starts, and everyone follows by playing a Spade.',
  'Each round, players must follow the suit that was led. Cards rank A, K, Q, J, 10 … 2.',
  'Whoever played the highest card of the round leads the next round.',
  'If you don’t have the suit in play, you may play any other card. That breaks the round: every card played goes to the player who played the highest card of the led suit.',
  'Empty your hand to escape. The last player left holding cards is the Bhabi — and loses.',
];

/**
 * Rules as a bounded screen: the numbered rules are paged to fit the space
 * left under the heading (all rules stay reachable with Back / Next, swipe or
 * ←/→, and the progress shows where you are).
 */
export const GameRulesPage: FC = () => {
  useEffect(() => {
    document.title = 'How to play · Bhabi';
  }, []);

  const blocks = useMemo(() => listToBlocks(GAME_RULES), []);

  return (
    <Screen asMain width="narrow">
      <header className="bh-screen__head">
        <p className="bh-eyebrow">Game rules</p>
        <h1 className="bh-screen__title">
          How to play <em>Bhabi</em>
        </h1>
        <p className="bh-screen__sub">
          Follow the suit, empty your hand — and don&apos;t be the last one
          holding cards.
        </p>
      </header>

      <PagedDocument
        className="bh-screen__fill"
        blocks={blocks}
        label="Rules"
        unit="Page"
        variant="rules"
      />

      <p className="bh-small bh-muted" style={{ margin: 0 }}>
        Ready?{' '}
        <Link to="/" className="bh-link">
          Deal a table
        </Link>
      </p>
    </Screen>
  );
};
